import { getAuthAxiosBackend } from "../helpers/axios"

class SocialMediaServices{

    get(id){
        return getAuthAxiosBackend().get('SocialMedia/getSocialMedia/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('SocialMedia/getSocialMediaByPersonId/' + personId)
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('SocialMedia/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('SocialMedia/addSocialMedia', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('SocialMedia/updateSocialMedia/' + id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('SocialMedia/softDeleteSocialMedia/' + id.toString())
    }
}

export default new SocialMediaServices()